//1602 local api
const baseApiURL = "https://staging-api.1602craftbeer.com";


var variantTypes = {
    type: "Type",
    size: "Size",
  };


export { baseApiURL, variantTypes };
